import React, { Component } from 'react';
import { instanceOf } from 'prop-types';
import { NotificationManager } from 'react-notifications';
import { withCookies, Cookies } from 'react-cookie';
import { TimestampToDate } from "@utils/date";

// Services
import postosService from '@services/postos';
import categoriesService from '@services/categories';
import productsService from '@services/products';

// Components
import Print from './print'
import ReactTable from '@components/ReactTable';
import Menu from '@components/Menu'
import Input from "@components/Input";
import Button from "@components/Button";
import AutoComplete from "@components/AutoComplete";

import { currentDateTime, currentTimestamp, dateToTimestamp } from '@utils/date'
import { twoDecimal } from '@utils/format.js';

import { CSVLink } from 'react-csv';

import 'react-smarttab/dist/index.css'

import UserContext from '@components/context/userContext';

class Page extends Component {
    static contextType = UserContext;

    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            stocks: {
                columns: [
                    {
                        Header: 'Código',
                        accessor: 'idproduct',
                    },
                    {
                      Header: 'Designação',
                      accessor: 'nome',
                    },
                    {
                      Header: 'Quantidade',
                      accessor: 'stock',
                    },
                    {
                        Header: 'Último Inventário',
                        accessor: 'inventory',
                      },
                    {
                      Header: 'Preço Custo',
                      accessor: 'costprice',
                    },
                    {
                      Header: 'V. Stock (€)',
                      accessor: 'total',
                    },
                ],
                rows: [],
                loading: false,
            },
            csv: {
              headers: [
                { label: "ProductCategory", key: "productCategory" },
                { label: "ProductCode", key: "productCode" },
                { label: "ProductDescription", key: "productDescription" },
                { label: "ProductNumberCode", key: "productNumberCode" },
                { label: "ClosingStockQuantity", key: "closingStockQuantity" },
                { label: "UnitOfMeasure", key: "unitOfMeasure" },
              ],
              data: []
            },
            date: currentDateTime(),
            categories: [],
            category: {
                value: "",
                label: "TODAS",
            },
            products: [],
            product: {
                value: "",
                label: "TODOS",
            },
            postos: [],
            posto: {
                value: "",
                label: "Selecione um posto",
            },
            astatus: [
              {
                value: "",
                label: "TODOS",
              },
              {
                value: " > 0",
                label: "Stock Positivo",
              },
              {
                value: " < 0",
                label: "Stock Negativo",
              },
            ],
            status: {
              value: "",
              label: "TODOS",
            },
            loaded: false,
        };

        this.loadFunction = this.loadFunction.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.getStocks = this.getStocks.bind(this);
    }

    getStocks() {
      const profile = this.context;
      const { date, posto, category, product, status } = this.state;

      this.setState({ stocks: { ...this.state.stocks, rows: [], loading: true } });

      if (posto.value === '') {
        this.setState({ stocks: { ...this.state.stocks, rows: [], loading: false } });
        NotificationManager.error('Nenhum posto selecionado', 'Tente selecionar um posto');
        return;
      }

      postosService.getStocksById(profile.idEmpresa, dateToTimestamp(date), posto.value, product.value || null, category.value || null)
        .then(stocks => {
            const filteredStocks = stocks.filter((eachStock) => eachStock.stock !== 'IDC' ? eval(eachStock.stock + status.value) : true);

            this.setState({
              stocks: { ...this.state.stocks,
                rows: filteredStocks.map((eachStock) => ({
                  ...eachStock,
                  inventory: eachStock.inventory ? TimestampToDate(eachStock.inventory) : '',
                  stock: eachStock.stock !== 'IDC' ? twoDecimal(parseFloat(eachStock.stock))+(dateToTimestamp(date) > currentTimestamp() ? ' (estimativa)' : '') : 'Impossível de prever',
                  total: eachStock.costprice && eachStock.stock && eachStock.stock !== 'IDC' ? twoDecimal(parseFloat(eachStock.costprice) * parseFloat(eachStock.stock)) : '',
                })),
                loading: false
              },
              csv: {
                ...this.state.csv,
                data: filteredStocks.map((eachStock) => ({
                  productCategory: 'M',
                  productCode: eachStock.idproduct,
                  productDescription: eachStock.nome,
                  productNumberCode: eachStock.idproduct,
                  closingStockQuantity: eachStock.stock !== 'IDC' ? twoDecimal(parseFloat(eachStock.stock)) : '',
                  unitOfMeasure: 'Unidades',
                }))
              },
            });
        })
        .catch(error => {
            NotificationManager.error(error.message, 'Existências em stock');
        });
    }

    async handleChange(e, callback) {
      let value = e.target.value;
      let name = e.target.name;

      await this.setState({
        [name]: value,
      });

      const { posto, category, product } = this.state;

      switch (name) {
        /*case "posto":
        case "category":
        case "product":
            localStorage.setItem(`stocks.${name}`, JSON.stringify(value));
            break;*/
        default:
            break;
        }

      if (['posto', 'category', 'date', 'product', 'status'].includes(name)) {
        if ((category !== '' || product !== '') && posto !== '') {
          this.getStocks();
        }
      }
    }

    async loadFunction() {
        const profile = this.context;

        if (!this.state.loaded) {
          try {
            const categories = await categoriesService.get(profile.idEmpresa);
            const enrichedCategories = categories.map((category) => ({ value: category.idcategoria, label: category.descricaocategoria }))

            this.setState({ categories: [{ value: '', label: 'TODAS' },...enrichedCategories] });

            const postos = await postosService.get(profile.idEmpresa);
            const enrichedPostos = postos.map((posto) => ({ value: posto.posto, label: posto.nome }));
        
            this.setState({ postos: [{ value: '', label: 'Selecione um posto' },...enrichedPostos] });

            const products = await productsService.getWithFilter(profile.idEmpresa, { mov_stock: true });
            this.setState({ 
              products: [{ value: '', label: 'TODOS' }, ...products.map((product) => ({ ...product, value: product.idproduct, label: product.nome }))], 
              loaded: true 
            }, () => {
              this.getStocks();
            });
          } catch (error) {
            console.error(error);
            NotificationManager.error(error.message, 'Erro ao carregar dados');
          }
        }
    }

    render () {
        const { location, history } = this.props;
        const { stocks, categories, products, date, postos, posto, category, product, status, astatus } = this.state;
        const cookies = new URLSearchParams(location.search);

        return (
          <div>
            <Menu
              loadFunction={this.loadFunction}
              location={location}
              history={history}
              newCookies={cookies}
            />
            <div className="fullContainer" style={{ maxWidth: "100%" }}>
              <div className="col-xs-12">
                <ol
                  style={{
                    textAlign: "left",
                    marginTop: "75px",
                  }}
                  className="breadcrumb"
                >
                  <li>
                    <a href="http://eposgestofinal.com/index.php">Portal</a>
                  </li>
                  <li className="active">Stocks</li>
                </ol>
              </div>
            </div>
            <div
                className="fullContainer"
                style={{ marginTop:'25px' }}
            >
                <div
                    className="col-sm-12"
                    style={{ textAlign: 'center', fontSize: '10px' }}
                >
                    <div className="panel panel-default">
                        <div
                            className="panel-heading"
                            style={{
                                fontWeight: 'bold',
                                fontSize: '15pt',
                            }}
                        >
                            Stocks
                        </div>
                      <h3>Filtros</h3>
                      <table className="table table-bordered table-hover table-sortable">
                          <thead>
                              <tr >
                                  <th className="text-center">Data</th>
                                  <th className="text-center">Estado</th>
                                  <th className="text-center">Familia</th>
                                  <th className="text-center">Produto</th>
                                  <th className="text-center">Posto *</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr >
                                  <td style={{ width: '250px' }}>
                                  <Input
                                      inputType={"datetime-local"}
                                      name={"date"}
                                      value={date}
                                      handleChange={this.handleChange}
                                  />
                                  </td>
                                  <td style={{ width: '250px' }}>
                                      <AutoComplete
                                          name={"status"}
                                          value={status}
                                          handleChange={this.handleChange}
                                          options={astatus}
                                      />
                                  </td>
                                  <td style={{ width: '250px' }}>
                                      <AutoComplete
                                          name={"category"}
                                          value={category}
                                          handleChange={this.handleChange}
                                          options={categories}
                                      />
                                  </td>
                                  <td>
                                      <AutoComplete
                                          name={"product"}
                                          value={product}
                                          handleChange={this.handleChange}
                                          options={products}
                                      />
                                  </td>
                                  <td style={{ width: '250px' }}>
                                      <AutoComplete
                                          name={"posto"}
                                          value={posto}
                                          handleChange={this.handleChange}
                                          options={postos}
                                      />
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                      <table style={{ marginBottom: 0 }} className="table table-bordered-only-inside">
                          <tbody>
                              <tr>
                              <td style={{ fontWeight: 'bolder', verticalAlign: 'middle', textAlign: 'right', display: 'flex', flexDirection: 'row', justifyContent: 'end', gap: '15px' }}>
                                      {stocks.rows.length > 0 ? (
                                          <CSVLink
                                              style={{ textDecoration: 'none' }}
                                              headers={this.state.csv.headers}
                                              data={this.state.csv.data}
                                              filename={'Inventario.csv'}
                                              target="_blank"
                                              separator=";"
                                              enclosingCharacter=""
                                          >
                                              <Button
                                                action={() => {}}
                                                type={"info"}
                                                title={"Inventário AT"}
                                              />
                                          </CSVLink>
                                      ) : null}
                                      {stocks.rows.length > 0 ? (
                                          <Print
                                              table={ stocks }
                                              date={ date }
                                              posto={ posto }
                                              category={ category }
                                              status={ status }
                                          />
                                      ) : null}
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                      {posto.value !== '' ? (
                        <>
                          <table style={{ marginBottom: 0 }} className="table">
                            <tbody>
                                <tr>
                                    <td  style={{ fontWeight: 'bolder', verticalAlign: 'middle', textAlign: 'right' }}>
                                    Total
                                    <h4>{twoDecimal(stocks.rows.reduce((acc, row) => acc + parseFloat(row.total || 0), 0))}</h4>
                                    </td>
                                </tr>
                            </tbody>
                          </table>
                          <ReactTable
                            columns={ stocks.columns }
                            sortable={ true }
                            loading={ stocks.loading }
                            data={ stocks.rows }
                            excelDownload={true}
                          />
                        </>
                      ) : (
                        <h1>Nenhum Posto Selecionado</h1>
                      )}
                  </div>
                </div>
            </div>
          </div>
        );
    }
}

export default withCookies(Page);